import C from "@/utils/constants";
import LenderReferrals from "@/views/console/LenderReferrals";

export default [
  {
    path: "lender-referrals",
    component: LenderReferrals,
    meta: {
      roles: [C.ROLE.LOAN_OFFICE_ADMIN],
    },
    children: [
      {
        path: "",
        name: "lender-referrals",
        component: () =>
          import("@/components/console/lender-referrals/LenderReferralsList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
          hotjar: true,
        },
      },
      {
        path: "view/:id",
        name: "view-lender-referral",
        components: {
          default: () =>
            import("@/components/console/lender-referrals/LenderReferralsList"),
          view: () =>
            import(
              "@/components/console/lender-referrals/LenderReferralDetail"
            ),
        },
        props: {
          view: (route) => {
            return {
              mode: "view",
              opportunityId: route.params.id,
              parent: "lender-referrals",
            };
          },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
          hotjar: true,
        },
      },
    ],
  },
];
